<template>
  <div>
    <el-row class="styleTagPanel" id="tagPanel">
      <el-col :span="3" v-for="(item, index) of menuList" :key="index">
        <div class="grid-content">
          <el-dropdown
            size="mini"
            type="primary"
            placement="bottom-start"
            :hide-on-click="false"
            @command="selectTag"
          >
            <span class="el-dropdown-link">{{ item.tagName }}</span>
            <span class="halving">|</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(list, listIndex) of item.tags"
                :key="listIndex"
                :command="list.tagId"
                >{{ list.tagName }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content">
          <el-popover
            placement="bottom"
            trigger="hover"
            popper-class="more-popper"
            v-model="showmore"
          >
            <div class="more">
              <div
                class="stylemore"
                v-for="(more, index) in moreDataList"
                :key="index"
                :style="{
                  'background-color':
                    more.jsonText && JSON.parse(more.jsonText).backgroundcolor
                }"
              >
                <div class="title">
                  {{ more.tagName }}
                </div>
                <div class="tag-data">
                  <ul v-for="(fordata, forindex) in more.tags" :key="forindex">
                    <li
                      v-for="data in fordata"
                      :key="data.tagId"
                      @click="searchTag(data.tagId)"
                    >
                      <div class="tagname">
                        <span class="tagname1">
                          {{ data.tagName }}
                          <i class="hot" v-if="data.hotSortId == 1"></i>
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <span class="el-dropdown-link" slot="reference"
              >更多
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <!-- <span class="el-dropdown-link"
            >更多
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span> -->
        </div>
      </el-col>
    </el-row>
    <el-row class="searchTagPanel" id="searchPanel" :gutter="0">
      <el-col :span="6">
        <el-input
          size="mini"
          placeholder="搜索样式"
          class="input-with-select"
          v-model="searchTagTxt"
          maxlength="7"
          minlength="1"
          autofocus="false"
          @input="searchChange"
          @keyup.enter.native="searchStyle"
        >
          <i
            slot="suffix"
            @click="searchStyle"
            class="el-input__icon el-icon-search"
          ></i>
        </el-input>
      </el-col>
      <el-col :span="7" class="festival">
        <span
          @click="searchTag(item.tagId)"
          v-for="(item, fid) of festivalList"
          :key="fid"
          :class="{ 'active-tag': tagId === item.tagId }"
          >{{ item.name }}</span
        >
      </el-col>
      <el-col :span="8" class="btnList">
        <div class="btnDiv">
          <div
            v-for="(btnName, btnIndex) of btnList"
            :key="btnIndex"
            @click="btnCheck(btnName.id)"
            :class="[isActiveBtn === btnName.id ? 'active' : '']"
          >
            {{ btnName.name }}
          </div>
        </div>
      </el-col>
      <el-col :span="2">
        <Course name="style" />
      </el-col>
    </el-row>
    <el-row>
      <!-- @MoreList="MoreList" -->
      <StyleList
        :style-data="styleDataList"
        :loading-new="loading"
        :isActiveBtn="isActiveBtn"
        :search-words="searchTagTxt"
        ref="showNoData"
        @getList="getList"
      >
      </StyleList>
      <div class="page" id="style-page">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="rowCount"
          :pager-count="5"
          @current-change="getList"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
// import {
//   // styleMenuColumn,
//   styleDataList,
// } from "../../assets/script/model/dataList";
import StyleList from "../../components/styles/StyleList";
import { mapActions } from "vuex";
import Course from "@/components/share/Course";

export default {
  name: "Styles.vue",
  components: {
    StyleList,
    Course
  },
  data() {
    return {
      // menuList: styleMenuColumn(),
      menuList: [],
      searchTagTxt: "",
      festivalList: [],
      btnList: [
        { name: "最新", id: 1 },
        { name: "最近", id: 2 },
        { name: "收藏", id: 3 }
      ],
      isActiveBtn: 1,
      styleDataList: [],
      moreDataList: [],
      showmore: false,
      tagId: 0,
      pageIndex: 1,
      pageSize: 20,
      rowCount: 0,
      loading: true
    };
  },
  async mounted() {
    var result = await this.ATag();
    if (result.errorCode === 0) {
      this.moreDataList = result.data.more;
      this.menuList = result.data.index;
      this.festivalList = result.data.hot;
    }
    this.search(this.searchTagTxt, this.tagId, 1);
  },
  methods: {
    ...mapActions("style", ["ATag", "AStyle"]),
    clearInput() {
      this.searchTagTxt = "";
    },
    searchChange() {
      if (this.searchTagTxt === "") {
        this.searchStyle();
      }
    },
    selectTag(command) {
      this.searchTagTxt = "";
      this.name = "";
      this.tagId = command;
      this.isActiveBtn = 1;
      this.pageIndex = 1;
      this.search(this.searchTagTxt, this.tagId, 1);
    },
    searchStyle() {
      this.tagId = 0;
      this.pageIndex = 1;
      this.name = this.searchTagTxt;
      this.search(this.searchTagTxt, this.tagId, 1);
    },
    btnCheck(id) {
      this.isActiveBtn = id;
      this.tagId = 0;
      this.searchTagTxt = "";
      this.pageIndex = 1;
      this.name = this.searchTagTxt;
      this.search(this.searchTagTxt, this.tagId, 1);
    },
    searchTag(tagId) {
      this.searchTagTxt = "";
      this.showmore = false;
      this.tagId = tagId;
      this.isActiveBtn = 1;
      this.pageIndex = 1;
      this.name = this.searchTagTxt;
      this.search(this.searchTagTxt, this.tagId, 1);
    },
    async search(name, tagId, pageindex) {
      this.scrollTop("el-table__body-wrapper", "class");
      this.pageIndex = pageindex;
      this.loading = true;
      this.$refs.pageLoading = true;
      var styleResult = await this.AStyle({
        name,
        tagId,
        pageindex,
        id: this.isActiveBtn,
        pageSize: this.pageSize
      });
      if (styleResult.errorCode === 0) {
        if (styleResult.data.rowCount > 0) {
          this.styleDataList = styleResult.data.dataSource;
          this.rowCount = styleResult.data.rowCount;
          this.$refs.showNoData.showDataList(false);
        } else {
          this.styleDataList = [];
          this.$refs.showNoData.showDataList(true);
          this.rowCount = 0;
        }
      } else {
        this.styleDataList = [];
        this.$refs.showNoData.showDataList(true);
        this.rowCount = 0;
        if (styleResult.errorCode === 300000) {
          this.insertConfig.showLoginMessage(
            true,
            "您当前账号暂未登录，请登录账号享更多权限",
            "StyleTag"
          );
        } else {
          this.$message({
            showClose: true,
            message: styleResult.errorMess,
            type: "error"
          });
        }
      }
      this.loading = false;
    },
    getList(pageIndex) {
      this.pageindex = pageIndex;
      this.search(this.name, this.tagId, this.pageindex);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
.pageIndex();
.input-with-select {
  /deep/.el-input__inner {
    border-radius: 20px;
    height: 25px;
    width: 115px;
  }
}

/deep/.el-button {
  padding: 5px 8px;
  display: inline-block;
  font-size: 12px;
  border-radius: 20px;
  border: 0;
}
/deep/.el-input__suffix {
  margin-top: -1px;
  cursor: pointer;
}

.grid-content {
  .halving {
    margin-left: 12px;
    color: #e6e6e6;
  }
}

.el-dropdown-menu__item {
  line-height: 30px;
  padding: 0 13px;
  font-size: 12px;
  color: @colorCheck;
  &:hover {
    color: @blue;
  }
}

.el-dropdown-link {
  font-size: 14px;
  cursor: pointer;
  color: @colorCheck;
  &:hover {
    color: @blue;
  }
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-icon--right {
  font-size: 10px;
}

.styleTagPanel {
  padding: 7px 20px;
  border-bottom: 1px solid #e6e6e6;
  background-color: #f5f8ff;
}
.searchTagPanel {
  padding: 7px 5px 7px 15px;
  border-bottom: 1px solid #e6e6e6;
  .festival {
    /*margin-top: 3px;*/
    margin-left: 5px;
    span {
      font-size: 12px;
      color: @colorCheck;
      cursor: pointer;
      margin-left: 8px;
      &:hover {
        color: @blue;
      }
    }
    .active-tag {
      color: @blue;
    }
  }
  .btnList {
    font-size: 12px;
    color: @colorCheck;
    margin-left: 0px;
    .btnDiv {
      display: inline-block;
      border: 2px solid #f5f8ff;
      border-radius: 15px;
      div {
        display: inline-block;
        padding: 3px 11px;
        border: 0;
        cursor: pointer;
      }
      .active {
        background-color: #f5f8ff;
        border: 1px solid @blue;
        color: @blue;
        border-radius: 15px;
        padding: 2px 10px;
      }
    }
  }
}
.more {
  display: flex;

  .stylemore {
    border-right: 1px dashed #dde4ea;
    padding-bottom: 10px;
    // display: flex;
    .title {
      font-weight: bolder;
      font-size: 14px;
      text-align: center;
      margin-top: 12px;
      margin-bottom: 5px;
    }
    .tag-data {
      display: flex;
    }
    .tagname {
      width: 90px;
    }
    .tagname1 {
      position: relative;
    }
    ul li {
      box-sizing: border-box;
      font-size: 12px;
      padding: 5px 0;
      padding-left: 20px;
      &:hover {
        color: @blue;
      }
      // width: 90px;
      cursor: pointer;
      // position: relative;
      .hot {
        position: absolute;
        top: -6px;
        right: -18px;
        background-image: url(../../assets/image/styles/hot.png);
        width: 17px;
        height: 11px;
      }
    }
    &:last-child {
      border-right: none;
    }
  }
}
.page {
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-course {
  color: #216bed;
  font-size: 14px;
  line-height: 16px;
  float: right;
  margin-right: 0 !important;
  position: absolute;
  top: 12px;
  right: 8px;
}
</style>
<style lang="less">
// .el-popover {
//   padding: 0 !important;
// }
.el-popover.more-popper {
  padding: 0 !important;
}
</style>
